var collapsibleSectionsAdmin = collapsibleSectionsAdmin || {};
(function($) {

	var GF_MARKUP_VERSION = 2;

	collapsibleSectionsAdmin.markupDetect = function() {
		if ( typeof window.form !== 'undefined' && window.form.hasOwnProperty('markupVersion') ) {
			GF_MARKUP_VERSION = ( window.form.markupVersion !== '' ) ? parseInt( window.form.markupVersion.toString(), 10 ) : 1;
		}
		return GF_MARKUP_VERSION;
	};

	collapsibleSectionsAdmin.isLegacyMode = function() {
		var useNewFeatures = ( collapsibleSectionsVars.hasOwnProperty('useNewFeatures') && collapsibleSectionsVars.useNewFeatures.toString() === 'true');
		return !useNewFeatures;
	};

	collapsibleSectionsAdmin.getSettingsElement = function() {
		var $fieldSettings = $('#field_settings_container');
		return $fieldSettings;
	};

	collapsibleSectionsAdmin.getField = function() {
		var field = GetSelectedField();
		var $field = $('#field_'+field.id);
		return $field;
	};

	collapsibleSectionsAdmin.OpenMediaLibrary = function( btnEl ) {
		if (typeof btnEl === 'undefined') {
			return;
		}

		var $setting = $(btnEl).closest('.collapsible-sections-field-setting');

		var collapsibleSections_fileFrame = $setting.data('file-frame');

		// If the media frame already exists, reopen it.
		if ( collapsibleSections_fileFrame ) {
			// Open frame
			collapsibleSections_fileFrame.open();
			return;
		}

		// Create the media frame.
		collapsibleSections_fileFrame = wp.media({
			title: 'Select an image to upload',
			button: {
				text: 'Use this image'
			},
			frame: 'post',
			state: 'insert',
			multiple: false	// Set to true to allow multiple files to be selected
		});

		setTimeout(function(){
			$('input[value="Insert into Post"]').val('Use this Image');
			$('button.media-button-insert').text('Use this Image');
		}, 100);

		jQuery('body').on('click', 'li.attachment', function(){
			$('input[value="Insert into Post"]').val('Use this Image');
			$('button.media-button-insert').text('Use this Image');
		});

		// When an image is selected, run a callback.
		collapsibleSections_fileFrame.on( 'insert', function(selection) {
			var state = collapsibleSections_fileFrame.state();
			selection = selection || state.get('selection');
			if (! selection) {
				return;
			}

			var attachment = selection.first();
			var selectedSize = "";

			var display = state.display(attachment).toJSON();
			attachment = attachment.toJSON();

			// start with the selected size, but fallback to one of the defaults if there's no image
			// this can happen eg when there are existing images in the media library when a new size is created, and thumbnails haven't been generated for existing
			// the size will appear as an option in the media library when selecting the image, but then fails as there's no image in that size
			var sizes = ["medium", "thumbnail", "full"];
			if ( display && display.hasOwnProperty('size') && display.size ) {
				sizes.unshift( display.size );
			}

			var img;
			if ( !attachment.hasOwnProperty('sizes') ) {
				img = attachment.url;
				selectedSize = "full";
			}
			else {
				var i = 0;
				var imageSize = sizes[i].toString();
				while ( !attachment.sizes.hasOwnProperty(imageSize) || !attachment.sizes[imageSize].hasOwnProperty('url') || attachment.sizes[imageSize].url === "" ) {
					i++;
					imageSize = sizes[i].toString();
				}
				img = attachment.sizes[imageSize].url;
				selectedSize = imageSize;
			}

			collapsibleSectionsAdmin.updateThemeImageUrl( img );

		});

		// Finally, open the modal
		collapsibleSections_fileFrame.open();
		$setting.data('file-frame', collapsibleSections_fileFrame);
	};


	collapsibleSectionsAdmin.toggleCollapsibleSections = function(value) {

		var field = GetSelectedField();
		var $field = collapsibleSectionsAdmin.getField();
		var $settings = collapsibleSectionsAdmin.getSettingsElement();

		if ( typeof value === 'undefined' ) {
			value = 'none';
		}

		var $toggle = $settings.find('input.collapsible_sections_toggle[value="'+value+'"]');

		var $title = $field.find('.gfield_admin_header_title');
		var fieldTitle = $title.html();

		SetFieldProperty('collapsibleSections_enableCollapsible', value);

		$toggle.prop('checked', true);

		var $themeSettings = $settings.find('.collapsible-sections-field-theme-setting');
		var $imageSetting = $settings.find('.collapsible-sections-field-image-url-setting');
		var $descriptionSetting = $settings.find('.collapsible-sections-field-description-setting');
		var $endSectionDisplay = $settings.find('.collapsible-sections-field-end-display-setting');

		if ( $imageSetting.length ) {
			$imageSetting.toggle( value !== 'none' );
		}

		var $collapsibleLabel = $field.find('.gsection_collapsible');
		var $collapsibleImage = $field.find('.gsection_collapsible_image');

		if (value !== 'none') {
			$field.addClass('collapsible-sections-admin-field');
			$settings.addClass('collapsible-sections-field-settings');

			if (value === 'start') {
				if ($themeSettings.length) {
					$themeSettings.show();
				}
				if ($descriptionSetting.length) {
					$descriptionSetting.show();
				}
				if ($endSectionDisplay.length) {
					$endSectionDisplay.hide();
				}
			}
			else if (value === 'end') {
				if ($themeSettings.length) {
					$themeSettings.hide();
				}
				if ($descriptionSetting.length) {
					$descriptionSetting.hide();
				}
				if ($endSectionDisplay.length) {
					$endSectionDisplay.show();
				}
			}

			var $title = $field.find('.gsection_title');

			var titleLabel = (value === 'end') ? 'Collapsible End' : 'Collapsible Start';
			if ( !$collapsibleImage.length ) {
				$collapsibleImage = $('<div class="gsection_collapsible_image"></div>').insertBefore( $title );
			}
			if ( !$collapsibleLabel.length ) {
				$collapsibleLabel = $('<div class="gsection_collapsible"></div>').insertBefore( $title );
			}
			$collapsibleLabel.attr('class', 'gsection_collapsible gsection_collapsible_'+value).html('<span>'+titleLabel+'</span>');

			if (field.hasOwnProperty('collapsibleSections_descriptionPlacement') && field.collapsibleSections_descriptionPlacement !== '') {
				collapsibleSectionsAdmin.updateDescriptionSetting(field.collapsibleSections_descriptionPlacement);
			}
			if (field.hasOwnProperty('collapsibleSections_endSectionDisplay') && field.collapsibleSections_endSectionDisplay !== '') {
				collapsibleSectionsAdmin.updateEndSectionDisplaySetting(field.collapsibleSections_endSectionDisplay);
			}

		}
		else {
			$field.removeClass('collapsible-sections-admin-field');
			$field.removeClass('collapsible-sections-description-default');
			$field.removeClass('collapsible-sections-description-inside');
			$field.removeClass('collapsible-sections-description-title');

			$settings.removeClass('collapsible-sections-field-settings');


			if ( $collapsibleLabel.length ) {
				$collapsibleLabel.remove();
			}
			if ( $collapsibleImage.length ) {
				$collapsibleImage.remove();
			}

			if ($themeSettings.length) {
				$themeSettings.hide();
				var $themeSettingsSelect = $settings.find('.collapsible-sections-theme');
				if ($themeSettingsSelect.length) {
					$themeSettingsSelect.val('form_setting').trigger('change');
				}
			}

			if ($descriptionSetting.length) {
				$descriptionSetting.hide();
				var $descriptionSettingSelect = $settings.find('.collapsible-sections-description-placement');
				if ($descriptionSettingSelect.length) {
					$descriptionSettingSelect.val('form_setting').trigger('change');
				}
			}

			if ($endSectionDisplay.length) {
				$endSectionDisplay.hide();
				var $endSectionDisplaySelect = $settings.find('.collapsible-sections-field-end-display');
				if ($endSectionDisplaySelect.length) {
					$endSectionDisplaySelect.val('default').trigger('change');
				}
			}
		}

	};


	collapsibleSectionsAdmin.updateEndSectionDisplaySetting = function( setting ) {
		SetFieldProperty('collapsibleSections_endSectionDisplay', setting);
	};

	collapsibleSectionsAdmin.updateDescriptionSetting = function( setting ) {
		SetFieldProperty('collapsibleSections_descriptionPlacement', setting);

		var field = GetSelectedField();
		var $field = $('#field_'+field.id);

		$field.removeClass('collapsible-sections-description-default');
		$field.removeClass('collapsible-sections-description-inside');
		$field.removeClass('collapsible-sections-description-title');

		$field.addClass('collapsible-sections-description-'+setting);
	};

	collapsibleSectionsAdmin.updateThemeImageUrl = function( value ) {
		SetFieldProperty( 'collapsibleSections_imageUrl', value );
		var $field = collapsibleSectionsAdmin.getField();
		var $settings = collapsibleSectionsAdmin.getSettingsElement();
		if ( value.trim() === '' ) {
			$settings.find('#collapsible-sections-image-preview').css('background-image', '').hide();
			$settings.find('#collapsible-sections-image-button').prop('disabled', false).show();
			$settings.find('#collapsible-sections-image-remove-button').prop('disabled', true).hide();
			$field.removeClass('cs--image').find('.gsection_collapsible_image').css('background-image', '');
		}
		else {
			$settings.find('#collapsible-sections-image-preview').css('background-image', 'url('+value+')').show();
			$settings.find('#collapsible-sections-image-remove-button').prop('disabled', false).show();
			$settings.find('#collapsible-sections-image-button').prop('disabled', true).hide();
			$field.addClass('cs--image').find('.gsection_collapsible_image').css('background-image', 'url('+value+')');
		}
	}

	collapsibleSectionsAdmin.formHasCollapsibleSections = function() {
		var hasCollapsibles = false;
		$.each(window.form.fields, function(i, field){
			if (field.type === 'section' && field.hasOwnProperty('collapsibleSections_enableCollapsible') && field.collapsibleSections_enableCollapsible !== 'none') {
				hasCollapsibles = true;
				return false;
			}
		});
		return hasCollapsibles;
	};

	collapsibleSectionsAdmin.formEditorLegacyWarning = function() {

		return;

		var alertMessage = [
			'<div class="gform-alert" data-js="gform-alert" role="status" data-gform-alert-instance="gfcs-legacy-alert-' + window.form.id.toString() + '">',
				'<span class="gform-alert__icon gform-icon gform-icon--warning" aria-hidden="true"></span>',
				'<div class="gform-alert__message-wrap">',
					'<p class="gform-alert__message">JetSloth\'s Collapsible Sections 1.2+ does not support legacy markup. Please update your forms settings and turn off legacy markup if you would like to continue using Collapsible Sections in this form.</p>',
					'<a class="gform-alert__cta gform-button gform-button--white gform-button--size-xs" href="' + window.collapsibleSectionsVars.form_settings + window.form.id.toString() + '#gform_setting_markupVersion" aria-label="">Form settings</a>',
				'</div>',
			'</div>',
		].join('');

		var $gfLegacyAlert = $('.simplebar-content > .gform-alert[data-gform-alert-instance^="gform-alert-"]:first');
		if ( $gfLegacyAlert.length ) {
			$gfLegacyAlert.after(alertMessage);
		}
		else {
			$('.simplebar-content').prepend(alertMessage);
		}
		gform.tools.trigger( 'gform_init_alerts' );

	};

	collapsibleSectionsAdmin.formEditorInit = function() {

		$.each(window.form.fields, function(i, field){
			if (field.type === 'section' && field.hasOwnProperty('collapsibleSections_enableCollapsible') && field.collapsibleSections_enableCollapsible !== 'none') {
				var enabledValue = field.collapsibleSections_enableCollapsible;
				var $field = $('#field_'+field.id);
				if ($field.length) {
					var $collapsibleLabel = $field.find('.gsection_collapsible');
					if ( !$collapsibleLabel.length ) {
						var titleLabel = (enabledValue === 'end') ? 'Collapsible End' : 'Collapsible Start';
						$field.find('.gsection_title').before('<div class="gsection_collapsible_image"></div><div class="gsection_collapsible gsection_collapsible_'+enabledValue+'"><span>'+titleLabel+'</span></div>');
					}

					if ( !collapsibleSectionsAdmin.isLegacyMode() ) {
						var imageUrl = ( field.hasOwnProperty('collapsibleSections_imageUrl') ) ? field.collapsibleSections_imageUrl : '';
						if ( imageUrl.trim() === '' ) {
							$field.removeClass('cs--image').find('.gsection_collapsible_image').css('background-image', '');
						}
						else {
							$field.addClass('cs--image').find('.gsection_collapsible_image').css('background-image', 'url('+imageUrl+')');
						}
					}
				}
			}
		});

	};

	$(document).bind('gform_load_field_settings', function (event, gfield, form) {

		var $settings = collapsibleSectionsAdmin.getSettingsElement();// $('#field_'+gfield.id + ' #field_settings');

		if (gfield.type === 'section') {

			$('#collapsible_sections_tab_toggle').show();

			if ( !collapsibleSectionsAdmin.isLegacyMode() ) {
				var imageUrl = (gfield.collapsibleSections_imageUrl !== undefined) ? gfield.collapsibleSections_imageUrl : '';
				collapsibleSectionsAdmin.updateThemeImageUrl( imageUrl );
			}

			var collapsibleValue = (typeof gfield.collapsibleSections_enableCollapsible !== 'undefined') ? gfield.collapsibleSections_enableCollapsible : 'none';
			if (collapsibleValue === true) {
				collapsibleValue = 'start';
			}
			else if (collapsibleValue === false) {
				collapsibleValue = 'none';
			}


			var $toggle = $settings.find('input.collapsible_sections_toggle[value="'+collapsibleValue+'"]');
			if ($toggle.length) {
				$toggle.prop('checked', true);
			}

			if (collapsibleValue === 'start') {
				$settings.find('.collapsible-sections-field-description-setting').show();
			}
			else if (collapsibleValue === 'end') {
				$settings.find('.collapsible-sections-field-end-display-setting').show();
			}


			$settings.find('.collapsible-sections-field-toggle-setting').show();
			collapsibleSectionsAdmin.toggleCollapsibleSections( collapsibleValue );

			var endSectionDisplay = (gfield.collapsibleSections_endSectionDisplay !== undefined) ? gfield.collapsibleSections_endSectionDisplay : 'default';
			var $endSectionDisplaySelect = $settings.find('.collapsible-sections-field-end-display');
			$endSectionDisplaySelect.val(endSectionDisplay);
			if ($endSectionDisplaySelect.find('option[selected]').length) {
				$endSectionDisplaySelect.find('option[selected]').removeAttr('selected');
			}
			$endSectionDisplaySelect.find('option[value="'+endSectionDisplay+'"]').prop('selected', true);
			collapsibleSectionsAdmin.updateEndSectionDisplaySetting(endSectionDisplay);


			var descriptionPlacement = (gfield.collapsibleSections_descriptionPlacement !== undefined) ? gfield.collapsibleSections_descriptionPlacement : 'form_setting';
			var $descriptionPlacementSelect = $settings.find('.collapsible-sections-description-placement');
			$descriptionPlacementSelect.val(descriptionPlacement);
			if ($descriptionPlacementSelect.find('option[selected]').length) {
				$descriptionPlacementSelect.find('option[selected]').removeAttr('selected');
			}
			$descriptionPlacementSelect.find('option[value="'+descriptionPlacement+'"]').prop('selected', true);
			collapsibleSectionsAdmin.updateDescriptionSetting(descriptionPlacement);

			if (typeof window.gform_initialize_tooltips === 'function') {
				window.gform_initialize_tooltips();
			}

		}
		else {

			collapsibleSectionsAdmin.toggleCollapsibleSections('none');

			setTimeout(function(){
				$('#collapsible_sections_tab_toggle').hide();
			}, 10);

		}

	});


	$(document).bind( 'gform_main_scripts_loaded', function() {

		if ( typeof window.form !== 'undefined' ) {
			var markupVersion = collapsibleSectionsAdmin.markupDetect();
			if ( markupVersion === 1 && collapsibleSectionsAdmin.formHasCollapsibleSections() ) {
				collapsibleSectionsAdmin.formEditorLegacyWarning();
			}
			collapsibleSectionsAdmin.formEditorInit();
		}


		// form/global settings theme preview
		var $settingsThemeSelect = $('#gf_collapsible_sections_theme, #gf_collapsible_sections_global_theme').first();
		var $settingsThemePreview = $('#gform_setting_gf_collapsible_sections_theme_preview .collapsible-sections-theme-preview, #gform_setting_gf_collapsible_sections_global_theme_preview .collapsible-sections-theme-preview').first();
		if ( $settingsThemeSelect.length && $settingsThemePreview.length ) {
			$settingsThemeSelect.on('change', function(e){
				var value = $(this).val();
				if ( value === "" || value === "global_setting" ) {
					value = ( collapsibleSectionsVars.hasOwnProperty('globals') && collapsibleSectionsVars.globals.hasOwnProperty('theme') ) ? collapsibleSectionsVars.globals.theme : ( collapsibleSectionsVars.hasOwnProperty('defaults') && collapsibleSectionsVars.defaults.hasOwnProperty('theme') ) ? collapsibleSectionsVars.defaults.theme : 'simple';
				}

				$settingsThemePreview.toggle(value !== 'none');
				if (value === 'none') {
					$settingsThemePreview.hide().find('img').hide();
				}
				else {
					$settingsThemePreview.find('img').hide();
					$settingsThemePreview.find('img.collapsible-sections-theme-preview-'+value).show();
				}
			});
			$settingsThemeSelect.trigger('change');
		}


		// Custom CSS editors
		var $customCssBoxes = $('#gf_collapsible_sections_custom_css_global, #gf_collapsible_sections_custom_css, #gf_collapsible_sections_user_css_global, #gf_collapsible_sections_user_css_form');
		if ( $customCssBoxes.length ) {
			var editorSettings = wp.codeEditor.defaultSettings ? _.clone( wp.codeEditor.defaultSettings ) : {};
			editorSettings.codemirror = _.extend(
				{},
				editorSettings.codemirror,
				{
					indentUnit: 4,
					tabSize: 4,
					mode: 'css',
					lineNumbers: true,
					autoCloseBrackets: true,
					continueComments: true,
					indentWithTabs: true,
					inputStyle: "contenteditable",
					lineWrapping: true,
					lint: false,
					matchBrackets: true,
					styleActiveLine: true,
					gutters: [],
					extraKeys: {
						"Alt-F": "findPersistent",
						"Cmd-F": "findPersistent",
						"Ctrl-F": "findPersistent",
						"Cmd-/": "toggleComment",
						"Ctrl-/": "toggleComment",
						"Ctrl-Space": "autocomplete",
					}
				}
			);
			$customCssBoxes.each(function(){
				window[this.id + '_editor'] = wp.codeEditor.initialize( $(this), editorSettings );
			});
		}

		var $legacyCssSectionToggle = $('#gform_settings_section_collapsed_gf_collapsible_sections_legacy_custom_css_section, #gform_settings_section_collapsed_gf_collapsible_sections_legacy_custom_css_global_section');
		if ( $legacyCssSectionToggle.length ) {
			$legacyCssSectionToggle.on('click', function(){
				$(this).closest('.gform-settings-panel').find('textarea').each(function(){
					var ref = $(this).attr('id') + '_editor';
					try {
						window[ref].codemirror.refresh();
					}
					catch(e) {
						// do nothing
					}
				});
			});
		}


		// show/hide new settings based on toggle
		var $legacyModeToggle = $('#_gform_setting_gf_collapsible_sections_use_legacy_styles');
		var $newFeaturesElements = $('#gform-settings-section-theme, #gform-settings-section-custom-css, #gform-settings-section-gf_collapsible_sections_legacy_custom_css_global_section .gform-settings-label');

		if ( $legacyModeToggle.length ) {
			$legacyModeToggle.on('change', function(e){
				var useLegacyMode = $legacyModeToggle.is(':checked');
				if ( $newFeaturesElements.length ) {
					$newFeaturesElements.toggle( !useLegacyMode );
				}
				if ( $legacyCssSectionToggle.length ) {
					if ( ( useLegacyMode && $legacyCssSectionToggle.is(":checked") ) || ( !useLegacyMode && !$legacyCssSectionToggle.is(":checked") ) ) {
						$legacyCssSectionToggle.click();
					}
				}
			});
			$legacyModeToggle.trigger('change');
		}


	});


})(jQuery);
